
import MainStore from "../store/MainStore";

class ERPFormService {

    getUserInfo(){
        let userInfo = {
            name: (MainStore.getState().MeReducer.name)?MainStore.getState().MeReducer.name:null,
            email: (MainStore.getState().MeReducer.email)?MainStore.getState().MeReducer.email:null,
            address: (MainStore.getState().MeReducer.entity && MainStore.getState().MeReducer.entity .address)?MainStore.getState().MeReducer.entity.address:null,
            phone: (MainStore.getState().MeReducer.entity && MainStore.getState().MeReducer.entity.phone)?MainStore.getState().MeReducer.entity.phone:null,
            siren: (MainStore.getState().MeReducer.entity && MainStore.getState().MeReducer.entity.siren)?MainStore.getState().MeReducer.entity.siren:null,
            cp:  (MainStore.getState().MeReducer.entity && MainStore.getState().MeReducer.entity.cp)?MainStore.getState().MeReducer.entity.cp:null,
            city:  (MainStore.getState().MeReducer.entity && MainStore.getState().MeReducer.entity.city)?MainStore.getState().MeReducer.entity.city:null,
        }
        return userInfo
    }

    getCurrentParcelles(){

        let currentParcelles = MainStore.getState().MapReducer.currentParcelle;
        return currentParcelles;
    }

    updateUserInfo(demInfo){
        MainStore.dispatch({type: 'UPDATE_DEMANDEUR_INFO', data:{demInfo: demInfo}})
    }

    getData(sectionName){

        let dataFetched = MainStore.getState().FormsReducer.formData;
        let sectionData = (dataFetched && dataFetched[sectionName])?dataFetched[sectionName].data:null;
       return sectionData

    }

    checkSyntheseCount(){

        let resultTraitmnt = new Promise((resolve, reject)=> {

            const params = {
                'key_parcelles': this.getCurrentParcelles()
            }

            let refSection = [
                {"nb": null, "typecode": "01", "name": "pprn", "label": "PPRn - Plan prévention des risques naturels"},
                {"nb": null, "typecode": "02", "name": "pprm", "label": "PPRm - Plan prévention des risques miniers"},
                {"nb": null, "typecode": "03", "name": "pprt", "label": "PPRt - Plan prévention des risques technologie"},
                {"nb": null, "typecode": "04", "name": "peb", "label": "PEB - Plan d'exposition aux bruits"},
                {"nb": null, "typecode": "05", "name": "sismique", "label": "Zonage sismique"},
                {"nb": null, "typecode": "06", "name": "radon", "label": "Zonage à potentiel radon"},
                {"nb": null, "typecode": "07", "name": "termite", "label": "Zonage termite"},
                {"nb": null, "typecode": "08", "name": "polution", "label": "Zonage pollution des sols (SIS)"},
            ]



            if (MainStore.getState().MeReducer.entity && MainStore.getState().MeReducer.entity.genre && MainStore.getState().MeReducer.entity.genre.slug=='professionnel') {

            axios.post('/Api/geodata/stat/parcelle/risque/erp', params)
                .then(result => {


                    refSection.map(item => {
                        switch (item.name) {
                            case ('sismique'):
                                item['nb'] = 1;
                                break;
                            case ('termite'):
                                item['nb'] = 1;
                                break;
                            case ('radon'):
                                item['nb'] = 1;
                                break;
                            default:
                                let countSection = _.find(result.data, (o) => {
                                    return o.risque_type == item.typecode
                                });
                                item['nb'] = (countSection) ? 1 : null;
                        }
                    })
                    resolve(refSection);

                }).catch(err => {
                console.log(err)
            })
        }else{resolve(refSection)}// hack fon non pro !!
        });


        return resultTraitmnt;
    }

}

export default ERPFormService
